 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/game-rules/pages/content/intellectual-property/pages/content/l/9f3ea104","2":"pages/cashbox/history/pages/cashbox/payin-error/pages/cashbox/payin-status-ext/pages/cashbox/payin-s/61fd3eac","18":"pages/index/pages/lobby/_section/pages/lobby/_section/_sub-section","20":"pages/cashbox/deposit/pages/cashbox/withdrawal","21":"pages/profile/pages/profile/bonuses/index","34":"header-c","35":"lang-ru.js","36":"lang-ua.js","37":"pages/auth/_social/cb","38":"pages/cashbox/deposit","39":"pages/cashbox/history","40":"pages/cashbox/index","41":"pages/cashbox/payin-error","42":"pages/cashbox/payin-status-ext","43":"pages/cashbox/payin-success","44":"pages/cashbox/payout-error","45":"pages/cashbox/payout-success","46":"pages/cashbox/support","47":"pages/cashbox/withdrawal","48":"pages/content/amlpolicy","49":"pages/content/faq","50":"pages/content/game-rules","51":"pages/content/intellectual-property","52":"pages/content/license","53":"pages/content/partners","54":"pages/content/privacy-policy","55":"pages/content/responsible-gaming","56":"pages/content/rules","57":"pages/error-game","58":"pages/game/_term","59":"pages/index","60":"pages/lobby/_section","61":"pages/lobby/_section/_sub-section","62":"pages/profile","63":"pages/profile/bonuses/index","64":"pages/profile/kycaid","65":"pages/profile/settings/index","66":"pages/profile/support-faq/index","67":"pages/promotions/_term","68":"pages/promotions/index","69":"pages/promotions/welcome-pack/index","70":"pages/registration","71":"pages/verifications/index","74":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"0bf0fbda7c8ef1c01514","1":"2255ae4b3964fa73f880","2":"83390e554c623e51125a","3":"de85935dd4ac46a1519f","4":"0c05e1bd465cd6a8e8b2","5":"7b5b4d9eb7579cccaf8b","6":"2fbe6ec13b887b995e1f","7":"8512214f11b9ea4e7a6f","8":"5043113936131ba66790","9":"e34bdf4dff7be00a3d71","10":"279fd10ed55c5f4efc23","11":"a587baedf788954ab4d5","12":"019a29fc742e77de86fa","13":"da574609c15c70cfaf22","14":"e9fb0233a1f7c52bbbcc","15":"cf63b82f01c18b558221","16":"0869e18976f46ec30a21","17":"f7bdfb7d9ec554a6ab63","18":"37f56b4a8cfae5074d42","19":"cb2a35aa20c25d5a82bc","20":"72dd52205915bae0c107","21":"62d7933e91259b655910","22":"08d0136d310f2e3bd840","23":"3a5ca152272cc06a8e7d","24":"3f77ffd7318672b10351","25":"1b8b596f010ace331700","26":"82a346b098fd5c417745","27":"3165a9b1f7ad1e5a29a6","28":"02040301c681370f006c","29":"afd0d46aabd3a6953bd6","30":"dd4e24f71f95a465c093","31":"53f0a7d8b1ac12c16d4b","34":"be7c7b2b3017acc84e57","35":"6c723b3a87a477f38277","36":"7a8d45b70810bc227dd2","37":"af61c98203a23465a1f6","38":"bbaae3a8366d3cde426d","39":"58712eae9afe6f37bdfb","40":"ac04b0099c7cf6d11805","41":"3f7ab50efa4981158b99","42":"c02235caa6478058098d","43":"940efe901a82254935ec","44":"af1c78344286a9018f61","45":"185740edf41193c56707","46":"aac1c269916fcf3634a8","47":"7fdd66a761b589701299","48":"8b1ade59043bb8157394","49":"a79bf7d4170a77eb9c63","50":"ac21ab2e9ac6c2d472d1","51":"3fa73691604743acd9fd","52":"0e6f715bfc0efd35f860","53":"a33f30074a0f9266775d","54":"0ad7a02f6aafb1c1570e","55":"a8977ab7f8bc422f6b0a","56":"38c3e82ff7a36db92857","57":"be529668d05e59135ad3","58":"548aae22c902dcc9ca2a","59":"53a69d379fdbf8088b4b","60":"53bf4981da4d24680700","61":"0125331eb868902d53a6","62":"dac015317fa5988c4912","63":"2bd84ae2dd0b8a900f6f","64":"fbb7a7343d31d5837736","65":"fa9c364ed455e156335c","66":"00c915f37dda8cc916bc","67":"5abe2e80aad438b99d4c","68":"1e0e46d9817c11c8f8f8","69":"94fba7330c3e7b6661f4","70":"45094c5b55abaee5b56d","71":"ef2c07e7caf0c3fe6177","74":"e0fe636732151c1e2863","75":"0ea38daadc973bf96d02","76":"68052653528df4350507","77":"d37f07e81ab0f058eb0a","78":"34845b335bd566636ada","79":"504942473fe36078ab9a","80":"43199732d1c2d206b5f6","81":"3ecaf0ea442753425931","82":"f5f7f05bc1ee2393d23d","83":"78ac23a42da1459f2f15","84":"0d619346e2419a9631d9","85":"c023ef4261f73ff8d778","86":"2d8eea575a5b07143b06","87":"42424a64bccd7a070dc4","88":"92220ea313fda12f9a58","89":"d9e9ba43bbad276de85e","90":"9382a6a85ca86fd4dd02","91":"9a7a31fa260770ddfa43","92":"dbffca959742f67d1b04","93":"d381082bb6ba2e3ae824","94":"ffd9d31eeb9ab4266042","95":"900014cfe56d3d9effab","96":"8651feaa889ec1163ec3","97":"634aaa07ca5da95251a6","98":"5f1d77b9548d86024fb4","99":"1021511c282ca7acfc43","100":"a52ae9709d3572d13958","101":"a500449830b9b32a65d2","102":"b6640528388507f44ebc","103":"1058c50d132a5b05b6d9","104":"dcfb65b4d2687ec87961","105":"368314f46473b147cc08","106":"b13779b14ea4263a1a6a","107":"2ae69b955d21fef6caf3","108":"93a973e6eaa7800a464c","109":"6e93fad0ac4302f47952","110":"02dc723af679c3a07a4d","111":"dea42698e371ac5556b1","112":"6e58e9ccef5c515b838e","113":"8cfc853fa61e5bfca2ef","114":"cad419b0564c12d2fe27","115":"3df8a384adb3cc42a93c","116":"7e6064403c4ad7c87e81","117":"a634c7b6fd2f2c96d58b","118":"1a3d0811fcd6fc0311a0","119":"3b121d5f4c250be911b2","120":"eec50201386ba3d6ca75","121":"7da577871cb6aa673d51","122":"c96471a5121102ea76c8","123":"a2b2292e64d54c6ff4a3","124":"49aa1ef9e53a259ee810","125":"6abc92d439fcb1ca97b4","126":"26cb7ae08c9655b4b719","127":"0b8d963a8a7113e85b57","128":"70e0d03e69caeb14fe03","129":"c3b483a714181ab5a569"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_static/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
